import { aggregationWalletServicesSchema } from './aggregation';

import { UnusedBalanceAggregationCriteriaKey } from '@/types';
import {
  InferType,
  string,
  object,
  date,
} from '@/validations/custom-yup';

export const unusedBalanceAggregationCriteriaSchema = string<UnusedBalanceAggregationCriteriaKey>()
  .label('集計基準')
  .required(({ label }) => `${label}を選択してください。`);

export const unusedBalanceAggregationPeriodSchema = object({
  startDateTime: date()
    .label('開始日')
    .required()
    .transform((value, originalValue) => (originalValue instanceof Date ? value : undefined)),
  endDateTime: date()
    .label('終了日')
    .required()
    .transform((value, originalValue) => (originalValue instanceof Date ? value : undefined)),
})
  .label('集計期間');

export const unusedBalanceAggreationUiFormSchema = object({
  aggregationPeriod: unusedBalanceAggregationPeriodSchema,
  criteria: unusedBalanceAggregationCriteriaSchema,
  walletServices: aggregationWalletServicesSchema,
});

export type UnusedBalanceAggregationUiFormSchema = InferType<typeof unusedBalanceAggreationUiFormSchema>;
